import routes from './routes';
import { SetRoutes } from 'components';

const RequestsPages = () => {
  return (
    <>
      <SetRoutes routes={routes} />
    </>
  );
};

export default RequestsPages;
